
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';

  @Component({})
  export default class OpenFile extends Vue {
    @Prop({required: true}) file_url!: string
  }
